module.exports = __webpack_public_path__ + "img/Certificate.f265ab7a.jpg";